import HttpClient from "@/common/boot/HttpClient"
import criarToast from '@/common/boot/ToastsHandler'
import EventBus from '@/common/helpers/EventBus'

const getWorkflowId = (workflow) => workflow?.id ?? null;

const listarHistoricoStar21 = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get('/gestao-producao/historico-star21', payload).then(response => {
    commit('LISTAR_DADOS', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}


const recuperarHistoricoStar21 = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get(`/gestao-producao/historico-star21/${payload}`, payload).then(response => {
    commit('INSERIR_HISTORICOSTAR21_SELECIONADA', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const apropriarTarefasEmLote = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  await HttpClient.post(`/gestao-producao/apropriar-tarefas-em-lote`, payload).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);
    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    })
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const apropriarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(`/pco-tarefas/apropriar/${payload}`, payload);
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    });

    const ticketId = getWorkflowId(response.data?.data?.workflow);

    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
      EventBus.$emit('tratativaAtualizada', ticketId);
    }

    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}


const adotarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(`/pco-tarefas/adotar/${payload}`, payload);
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    });

    const ticketId = getWorkflowId(response.data?.data?.workflow);

    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
      EventBus.$emit('tratativaAtualizada', ticketId);
    }

    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}


const liberarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(`/pco-tarefas/liberar/${payload}`, payload);
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    });

    const ticketId = getWorkflowId(response.data?.data?.workflow);

    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
      EventBus.$emit('tratativaAtualizada', ticketId);
    }

    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}


const adotarTarefasEmLote = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.post(`/gestao-producao/adotar-tarefas-em-lote`, payload).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    })

    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const iniciarTratamentoTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.post(`/gestao-producao/iniciar-tratamento/${payload}`).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const devolverTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get(`/gestao-producao/devolver-tarefas/${payload}`).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    })

    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const devolverTarefasEmLote = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.post(`/gestao-producao/devolver-tarefas-em-lote`, payload).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    criarToast({
      tipo: 'success',
      mensagem: response.data.message.success[0]
    })

    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const buscarDadosFichaTecnica = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get(`/pco-workflows/recuperacao/ticket/${payload}`).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data);
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const buscarDadosFichaTecnicaTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get(`/pco-tarefas/${payload}/detalhes`).then(response => {
    commit('INSERIR_FICHA_TECNICA_TAREFA', response.data.data);
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const concluirTratamentoTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(`/gestao-producao/concluir-tratamento`, payload);
    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tratativa concluída com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao concluir tratativa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const salvarDadosFormulario = ({ commit }, payload) => {
  commit('')

  HttpClient.post(`/gestao-producao/pco-tratamento-formulario`, payload).then(response => {
    return response
  })
}

const limparFichaTecnica = async ({ commit }) => {
  commit('LIMPAR_FICHA_TECNICA')
}

const desagruparTarefasBloco = ({ commit }, payload) => {
  commit('CARREGANDO', true);

  HttpClient.post(`/gestao-producao/pco-tarefas/atualiza-agrupavel`, payload).then(response => {
    commit('INSERIR_FICHA_TECNICA', response.data.data)
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const concluirSemIniciarTratamento = ({ commit }, payload) => {
  commit("INSERE_STATUS_CODE_ULTIMA_REQUISICAO", 422)
  commit('CARREGANDO', true);
  HttpClient.post(`/gestao-producao/tratativas-sem-tratamento`, payload).then(response => {
    commit("INSERE_STATUS_CODE_ULTIMA_REQUISICAO", 200)
    commit('INSERIR_FICHA_TECNICA', response.data.data);
    return response
  }).catch(error => {
    commit("INSERE_STATUS_CODE_ULTIMA_REQUISICAO", error.response.status)
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}


const atualizaSolicitacaoCancelamento = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  await HttpClient.post(`/gestao-producao/atualiza-solicitacao-cancelamento`, payload).then(response => {
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const atualizaAvisoDeMulta = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  await HttpClient.post(`/gestao-producao/atualiza-aviso-multa`, payload).then(response => {
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const atualizaProjetoCircuito = async ({ commit }, payload) => {
  commit('CARREGANDO', true)
  await HttpClient.post(`/gestao-producao/atualiza-projeto-circuito`, payload).then(response => {
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const desfazerBloco = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.post(`/gestao-producao/pco-tarefas/desfazer-bloco`, payload).then(async response => {
    await commit('INSERIR_FICHA_TECNICA', response.data.data);
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const buscarDadosHistoricoFichaTecnica = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.post(`/gestao-producao/dados-historico-ficha-tecnica/${payload.pco_tarefa_id[0]}`, payload).then(response => {
    commit('INSERIR_HISTORICO_FICHA_TECNICA', response.data.data);
    return response
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const limparDadosHistorico = async ({ commit }) => {
  commit('LIMPAR_HISTORICO_FICHA_TECNICA');
}

const buscarHistoricoTicket = async ({ commit }, ticketId) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.get(`/pco-workflows/${ticketId}/historico`);
    commit('INSERIR_HISTORICO_TICKET', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const listarOpcoesTratativasTarefas = async ({ commit }, payload) => {
  commit('CARREGANDO_OPCOES_TRATATIVAS_TAREFAS', true);

  const params = {
    ctrl_tarefa_id: payload.ctrl_tarefa_id,
    ctrl_tratativa_id: payload.ctrl_tratativa_id
  };

  await HttpClient.get('/ctrl-tarefas/tratamento/disponiveis', { params }).then(response => {
    commit('LISTA_OPCOES_TRATATIVAS_TAREFAS', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO_OPCOES_TRATATIVAS_TAREFAS', false);
  });
}

const listaDadosFichaTecnicaAdocao = async ({ commit }, pco_circuito_adocao_id) => {
  commit('CARREGANDO_ADOCAO', true);

  await HttpClient.get(`/gestao-producao/pco-circuitos-adocao/${pco_circuito_adocao_id}`).then(response => {
    commit('INSERIR_DADOS_ADOCAO', response.data.data);
    return response;
  })
    .finally(() => {
      commit('CARREGANDO_ADOCAO', false);
    });
}

const listarCircuitoPcoTarefasLog = ({ commit }, payload) => {
  commit('CARREGANDO_PCO_TAREFAS', true);
  HttpClient.post(`/gestao-producao/pco-circuito-log/${payload.pco_circuito_id}`, payload).then(async response => {
    if (!payload.current_page) {
      await commit('REMOVER_DADOS_PCO_TAREFAS_LOG', [])
    }
    commit('INSERIR_DADOS_PCO_TAREFAS_LOG', response.data.data);
    return response;
  })
    .finally(() => {
      commit('CARREGANDO_PCO_TAREFAS', false);
    });
}

const listarTratativas = async ({ commit }) => {
  commit('CARREGANDO', true);

  return await HttpClient.get('/ctrl-tratativas').then(response => {
    commit('INSERIR_LISTA_TRATATIVAS', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const tratativasPorCtrlTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  if (!payload) {
    commit('INSERIR_LISTA_TRATATIVAS', []);
    commit('CARREGANDO', false);
    return [];
  }

  return await HttpClient.get(`/ctrl-tratativas/${payload}/tarefas`).then(response => {
    commit('INSERIR_LISTA_TRATATIVAS', response.data.data);
    return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const avancarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `/pco-tarefas/avancar/${payload.pco_tarefa_id}/${payload.ctrl_tarefa_id}`,
      {
        dados_formulario_tarefa: payload.dados_formulario_tarefa,
        ctrl_formulario_id: payload.ctrl_formulario_id
      }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tarefa avançada com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao avançar tarefa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const devolverTarefaWorkflow = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `/pco-tarefas/devolver/${payload.pco_tarefa_id}/${payload.ctrl_tarefa_id}`,
      {
        dados_formulario_tarefa: payload.dados_formulario_tarefa,
        ctrl_formulario_id: payload.ctrl_formulario_id
      }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tarefa devolvida com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao devolver tarefa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const atualizarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const formData = new FormData();
    formData.append('descricao', payload.descricao);
    if (payload.anexos && payload.anexos.length > 0) {
      payload.anexos.forEach(arquivo => formData.append('anexos[]', arquivo));
    }

    const response = await HttpClient.post(
      `/pco-tarefas/atualizar/${payload.pco_tarefa_id}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tarefa atualizada com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao atualizar tarefa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const interromperTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `/pco-tarefas/interromper/${payload.pco_tarefa_id}/${payload.ctrl_tarefa_id}`,
      {
        dados_formulario_tarefa: payload.dados_formulario_tarefa,
        ctrl_formulario_id: payload.ctrl_formulario_id
      }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tarefa interrompida com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao interromper tarefa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const solicitarInterrupcao = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `/pco-tarefas/solicitar-interrupcao/${payload.pco_tarefa_id}/${payload.ctrl_tarefa_id}`,
      {
        dados_formulario_tarefa: payload.dados_formulario_tarefa,
        ctrl_formulario_id: payload.ctrl_formulario_id
      }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Solicitação de interrupção enviada com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao solicitar interrupção'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const cancelarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const formData = new FormData();
    formData.append('descricao', payload.descricao);
    if (payload.anexos && payload.anexos.length > 0) {
      payload.anexos.forEach(arquivo => formData.append('anexos[]', arquivo));
    }

    const response = await HttpClient.post(
      `/pco-tarefas/cancelar/${payload.pco_tarefa_id}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Tarefa cancelada com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao cancelar tarefa'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const negarInterrupcao = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.post(
      `/pco-tarefas/negar-interrupcao/${payload.pco_tarefa_id}`,
      {
        dados_formulario_tarefa: payload.dados_formulario_tarefa,
        ctrl_formulario_id: payload.ctrl_formulario_id
      }
    );

    commit('INSERIR_FICHA_TECNICA', response.data.data);

    const ticketId = getWorkflowId(response.data?.data?.workflow);
    if (ticketId) {
      await dispatch('buscarHistoricoTicket', ticketId);
    }

    criarToast({
      tipo: 'success',
      mensagem: response.data.message?.success?.[0] || 'Interrupção negada com sucesso'
    });

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao negar interrupção'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const vincularTecnicos = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.put(
      `/pco-workflows/${payload.pco_workflow_id}/vincular-tecnicos`, payload
    );
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const listarTecnicosPorWorkflow = async ({ commit }, pcoWorkflowId) => {
  commit('CARREGANDO', true);

  try {
    const response = await HttpClient.get(
      `/pco-workflows/${pcoWorkflowId}/listar-tecnicos`
    );

    return response.data?.data;
  } finally {
    commit('CARREGANDO', false);
  }
};

const classificarTicket = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  try {
    const body = {}

    if (payload.ctrl_provedor_id !== undefined && payload.ctrl_provedor_id !== null) {
      body.ctrl_provedor_id = payload.ctrl_provedor_id
    }

    if (payload.designacao_claro !== undefined && payload.designacao_claro !== null) {
      body.designacao_claro = payload.designacao_claro
    }

    const response = await HttpClient.patch(
      `/pco-workflows/recuperacao/ticket/tarefas/${payload.pcoTarefaId}/classificar`,
      body
    );

    criarToast({
      tipo: 'success',
      mensagem: response.data.message || 'Ticket classificado com sucesso.'
    });

    await dispatch('buscarDadosFichaTecnicaTarefa', payload.pcoTarefaId);

    return response;
  } catch (error) {
    criarToast({
      tipo: 'error',
      mensagem: error.response?.data?.message || 'Erro ao classificar ticket.'
    });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

export {
  listarHistoricoStar21,
  recuperarHistoricoStar21,
  salvarDadosFormulario,
  adotarTarefa,
  adotarTarefasEmLote,
  devolverTarefa,
  devolverTarefasEmLote,
  iniciarTratamentoTarefa,
  buscarDadosFichaTecnica,
  buscarDadosFichaTecnicaTarefa,
  concluirTratamentoTarefa,
  apropriarTarefa,
  apropriarTarefasEmLote,
  limparFichaTecnica,
  desagruparTarefasBloco,
  concluirSemIniciarTratamento,
  atualizaSolicitacaoCancelamento,
  desfazerBloco,
  buscarDadosHistoricoFichaTecnica,
  atualizaAvisoDeMulta,
  listarOpcoesTratativasTarefas,
  listaDadosFichaTecnicaAdocao,
  limparDadosHistorico,
  buscarHistoricoTicket,
  listarCircuitoPcoTarefasLog,
  atualizaProjetoCircuito,
  listarTratativas,
  avancarTarefa,
  devolverTarefaWorkflow,
  atualizarTarefa,
  interromperTarefa,
  solicitarInterrupcao,
  negarInterrupcao,
  cancelarTarefa,
  liberarTarefa,
  classificarTicket,
  tratativasPorCtrlTarefa,
  vincularTecnicos,
  listarTecnicosPorWorkflow,
}
